import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";

import { FaSave, FaLink, FaTrash, FaPaperPlane, FaTimes } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import * as Tooltip from "@radix-ui/react-tooltip";
import { FaComments } from "react-icons/fa6";
import { LuMails } from "react-icons/lu";
import { LuMessageCircle } from "react-icons/lu";
import { LuMail } from "react-icons/lu";
import * as Toast from "@radix-ui/react-toast";
import * as Dialog from "@radix-ui/react-dialog";
import { FaMapMarkerAlt } from "react-icons/fa";
import updateChurchData from '../API/updateChurchData';


// const SavePreview = ({ church, setData }) => {
    const SavePreview = forwardRef(({ data, setData }, ref) => {
        // ... existing code ...
     
    const church = data;

  const [expandedColumns, setExpandedColumns] = React.useState({});
  const [churchData, setChurchData] = useState(church);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showContact2, setShowContact2] = useState(true);
  const [showContact3, setShowContact3] = useState(true);
  const [usePhysicalForMailing, setUsePhysicalForMailing] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: "", message: "" });
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const context = { usePhysicalForMailing, showContact2, showContact3 };
  const [contactToDelete, setContactToDelete] = useState(null);

  



  useImperativeHandle(ref, () => ({
    validateAllFields() {
      return validateAllFields();
    },
  }));
  
  const validateAllFields = () => {
    const errors = [];
    Object.keys(churchData).forEach(fieldName => {
      const validationResult = validateField(fieldName, churchData[fieldName], context, churchData);
      if (!validationResult.isValid) {
        errors.push({
          field: fieldName,
          message: validationResult.message
        });
      }
    });
    return errors;
  };
  
  
  
  
  
  
//   React.useEffect(() => {
//     if (onValidate) {
//       onValidate(() => validateAllFields());
//     }
//   }, [onValidate, churchData]);
  
  
  
  
  const handleInputChange = (field, value) => {
    setChurchData((prevData) => {
      const newData = {
        ...prevData,
        [field]: value !== null ? value : "",
      };
      setData(newData); // This updates the parent's state
      return newData;
    });
  };
  

//   const handleRemoveContact = (contactNumber) => {
//     if (contactNumber === 2) {
//       setShowContact2(false);
//       setChurchData((prev) => ({
//         ...prev,
//         contact2_name: "",
//         contact2_phone: "",
//         contact2_email: "",
//         contact2_public: false,
//         contact2_display_email: false,
//         contact2_display_phone: false,
//         contact2_preferred_email: false,
//         contact2_preferred_text: false,
//         contact2_preferred_call: false,
//       }));
//     } else if (contactNumber === 3) {
//       setShowContact3(false);
//       setChurchData((prev) => ({
//         ...prev,
//         contact3_name: "",
//         contact3_phone: "",
//         contact3_email: "",
//         contact3_public: false,
//         contact3_display_email: false,
//         contact3_display_phone: false,
//         contact3_preferred_email: false,
//         contact3_preferred_text: false,
//         contact3_preferred_call: false,
//       }));
//     }
//   };
const handleRemoveContact = (contactNumber) => {
    setContactToDelete(contactNumber);
    setOpenConfirmDialog(true);
  };
  
  const confirmDeleteContact = () => {
    if (contactToDelete === 2 || contactToDelete === 3) {
      const updatedData = {
        ...churchData,
        [`contact${contactToDelete}_name`]: "",
        [`contact${contactToDelete}_phone`]: "",
        [`contact${contactToDelete}_email`]: "",
        [`contact${contactToDelete}_public`]: false,
        [`contact${contactToDelete}_display_email`]: false,
        [`contact${contactToDelete}_display_phone`]: false,
        [`contact${contactToDelete}_preferred_email`]: false,
        [`contact${contactToDelete}_preferred_text`]: false,
        [`contact${contactToDelete}_preferred_call`]: false,
      };
      setChurchData(updatedData);
      setData(updatedData); // This updates the parent's state
      if (contactToDelete === 2) {
        setShowContact2(false);
      } else {
        setShowContact3(false);
      }
    }
    setOpenConfirmDialog(false);
  };
  


  const handleAddContact = () => {
    if (!showContact2) {
      setShowContact2(true);
    } else if (!showContact3) {
      setShowContact3(true);
    }
  };

  useEffect(() => {
    setShowContact2(isContactPopulated(2));
    setShowContact3(isContactPopulated(3));
  }, [churchData]);

  const isContactPopulated = (contactNumber) => {
    const nameField = `contact${contactNumber}_name`;
    const phoneField = `contact${contactNumber}_phone`;
    const emailField = `contact${contactNumber}_email`;
    const publicField = `contact${contactNumber}_public`;
    const displayEmailField = `contact${contactNumber}_display_email`;
    const displayPhoneField = `contact${contactNumber}_display_phone`;

    return (
      churchData[nameField] ||
      churchData[phoneField] ||
      churchData[emailField] ||
      churchData[publicField] ||
      churchData[displayEmailField] ||
      churchData[displayPhoneField]
    );
  };

  useEffect(() => {
    let timer;
    if (showTooltip) {
      timer = setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [showTooltip]);

//   const handleInputChange = (field, value) => {
//     setChurchData((prevData) => ({
//       ...prevData,
//       [field]: value !== null ? value : "",
//     }));
//   };

  const Input = ({ label, initialValue, placeholder, onBlur, className }) => {
    const [value, setValue] = useState(initialValue);
    const handleChange = (e) => {
      setValue(e.target.value);
    };

    const handleBlur = () => {
      onBlur(value);
    };

    return (
      <div className="mb-1">
        <div className="text-[12px] font-bold">{label}</div>
        <input
          className={`w-full text-[12px] h-6 border-0 border-b border-gray-300 p-0 m-0 ${className}`}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    );
  };

  const Column = ({ title, children }) => {
    const isExpanded = expandedColumns[title];
    const toggleExpand = () => {
      setExpandedColumns((prev) => ({ ...prev, [title]: !prev[title] }));
    };

    return (
      <div className="border border-gray-300">
        <div
          //   #2c3e50
          className="bg-[#3498db] text-white p-1 font-bold text-[12px] flex justify-between items-center cursor-pointer sm:cursor-default"
          onClick={toggleExpand}
        >
          {title}
          <span className="sm:hidden">{isExpanded ? "▲" : "▼"}</span>
        </div>
        <div className={`p-1 ${isExpanded ? "block" : "hidden"} sm:block`}>
          {children}
        </div>
      </div>
    );
  };




  const InputComponent = ({
    label,
    initialValue = "",
    onInputChange,
    placeholder,
    fieldName,
    context = {},
  }) => {
    const [value, setValue] = useState(initialValue ?? "");
    const [validationState, setValidationState] = useState(
      validateField(fieldName, initialValue, context, churchData)
    );

    const handleChange = (e) => {
      const newValue = e.target.value;
      setValue(newValue);
      setValidationState(
        validateField(fieldName, newValue, context, churchData)
      );
    };

    const handleBlur = () => {
      onInputChange(fieldName, value);
    };

    return (
      <div className="mb-1">
        <div className="text-[12px] font-bold">{label}</div>
        <input
          className={`w-full text-[12px] h-6 border-0 border-b ${
            validationState.isValid ? "border-gray-300" : "border-red-500"
          } p-0 m-0`}
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {!validationState.isValid && (
          <div className="text-red-500 text-xs mt-1">
            {validationState.message}
          </div>
        )}
      </div>
    );
  };

  const validateField = (fieldName, value, context = {}, churchData = {}) => {
    // Ensure value is a string
    // const val = (value ?? "").trim();
    const val = typeof value === "string" ? value.trim() : value ?? "";

    switch (fieldName) {
      // Physical Location validations
      case "address":
        if (val === "") {
          return { isValid: false, message: "Address is required" };
        } else if (val.length < 5) {
          return {
            isValid: false,
            message: "Address must be at least 5 characters long",
          };
        }
        return { isValid: true, message: "" };

      case "city":
        if (val === "") {
          return { isValid: false, message: "City is required" };
        }
        return { isValid: true, message: "" };

      case "state":
        if (val === "") {
          return { isValid: false, message: "State is required" };
        }
        return { isValid: true, message: "" };

      case "zip":
        if (val === "") {
          return { isValid: false, message: "ZIP is required" };
        } else if (!/^\d{5}(-\d{4})?$/.test(val)) {
          return { isValid: false, message: "ZIP code is invalid" };
        }
        return { isValid: true, message: "" };

      case "lat":
      case "lon":
        // Optional fields, but if provided, must be valid numbers
        if (val !== "" && isNaN(val)) {
          return { isValid: false, message: "Must be a valid number" };
        }
        return { isValid: true, message: "" };

      // Mailing Address validations
      case "mailing_address":
      case "mailing_city":
      case "mailing_state":
      case "mailing_zip":
        if (!context.usePhysicalForMailing) {
          if (val === "") {
            const fieldLabel = fieldName
              .replace("mailing_", "")
              .replace("_", " ");
            return {
              isValid: false,
              message: `${capitalize(fieldLabel)} is required`,
            };
          }
        }
        return { isValid: true, message: "" };

      // Service Schedule validations
      case "sunday_am":
        if (val === "") {
          return { isValid: false, message: "Sunday AM is required" };
        } else if (!isValidTime(val)) {
          return { isValid: false, message: "Sunday AM time is invalid" };
        }
        return { isValid: true, message: "" };

      case "sunday_pm":
        if (val !== "" && !isValidTime(val)) {
          return { isValid: false, message: "Sunday PM time is invalid" };
        }
        return { isValid: true, message: "" };

      case "midweek":
        // Optional, no validation needed
        return { isValid: true, message: "" };

      // Contacts validations
      case "contact1_name":
      case "contact2_name":
      case "contact3_name":
        const contactNumber = fieldName.charAt(7); // '1', '2', or '3'
        const isContactActive =
          contactNumber === "1" ||
          (contactNumber === "2" && context.showContact2) ||
          (contactNumber === "3" && context.showContact3);

        if (!isContactActive) {
          return { isValid: true, message: "" };
        }

        if (val === "") {
          return {
            isValid: false,
            message: `Name is required`,
          };
        }
        return { isValid: true, message: "" };

      case "contact1_phone":
      case "contact2_phone":
      case "contact3_phone": {
        const contactNumber = fieldName.charAt(7); // '1', '2', or '3'
        const isContactActive =
          contactNumber === "1" ||
          (contactNumber === "2" && context.showContact2) ||
          (contactNumber === "3" && context.showContact3);

        if (!isContactActive) {
          return { isValid: true, message: "" };
        }

        // Collect phone numbers from all active contacts
        const phones = [
          { phone: churchData.contact1_phone, isActive: true },
          { phone: churchData.contact2_phone, isActive: context.showContact2 },
          { phone: churchData.contact3_phone, isActive: context.showContact3 },
        ];

        // Filter to active contacts
        const activePhones = phones.filter((contact) => contact.isActive);

        // Exclude the current contact's phone when checking other valid phones
        const idxToExclude = parseInt(contactNumber) - 1;

        const otherValidPhones = activePhones
          .filter((contact, idx) => idx !== idxToExclude)
          .map((contact) => contact.phone)
          .filter((phone) => phone && isValidPhoneNumber(phone));

        if (val === "") {
          if (otherValidPhones.length === 0) {
            return {
              isValid: false,
              message: "At least one contact must have a valid phone number",
            };
          } else {
            return { isValid: true, message: "" };
          }
        } else {
          if (!isValidPhoneNumber(val)) {
            return { isValid: false, message: "Phone number is invalid" };
          } else {
            return { isValid: true, message: "" };
          }
        }
      }

      case "contact1_email":
      case "contact2_email":
      case "contact3_email": {
        const contactNumber = fieldName.charAt(7); // '1', '2', or '3'
        const isContactActive =
          contactNumber === "1" ||
          (contactNumber === "2" && context.showContact2) ||
          (contactNumber === "3" && context.showContact3);

        if (!isContactActive) {
          return { isValid: true, message: "" };
        }

        // Collect emails from all active contacts
        const emails = [
          { email: churchData.contact1_email, isActive: true },
          { email: churchData.contact2_email, isActive: context.showContact2 },
          { email: churchData.contact3_email, isActive: context.showContact3 },
        ];

        // Filter to active contacts
        const activeEmails = emails.filter((contact) => contact.isActive);

        // Exclude the current contact's email when checking other valid emails
        const idxToExclude = parseInt(contactNumber) - 1;

        const otherValidEmails = activeEmails
          .filter((contact, idx) => idx !== idxToExclude)
          .map((contact) => contact.email)
          .filter((email) => email && isValidEmail(email));

        if (val === "") {
          if (otherValidEmails.length === 0) {
            return {
              isValid: false,
              message: "At least one contact must have a valid email",
            };
          } else {
            return { isValid: true, message: "" };
          }
        } else {
          if (!isValidEmail(val)) {
            return { isValid: false, message: "Email is invalid" };
          } else {
            return { isValid: true, message: "" };
          }
        }
      }

      // Church Details validations (all optional)
      case "website":
      case "facebook_link":
      case "preferred_contact_method":
      case "notes":
        return { isValid: true, message: "" };

      default:
        return { isValid: true, message: "" };
    }
  };

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  const isValidTime = (value) => {
    // Simple time validation (e.g., "10:30 AM")
    const timeRegex = /^([1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i;
    return timeRegex.test(value);
  };

  const isValidPhoneNumber = (value) => {
    // Simple US phone number validation
    const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneRegex.test(value);
  };

  const isValidEmail = (value) => {
    // Simple email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };



const handleMailingAddressToggle = (isChecked) => {
  setUsePhysicalForMailing(isChecked);
  const updatedData = {
    ...churchData,
    mailing_same_as_physical: isChecked,
    mailing_name: isChecked ? "" : churchData.mailing_name,
    mailing_address: isChecked ? "" : churchData.mailing_address,
    mailing_city: isChecked ? "" : churchData.mailing_city,
    mailing_state: isChecked ? "" : churchData.mailing_state,
    mailing_zip: isChecked ? "" : churchData.mailing_zip,
  };
  setChurchData(updatedData);
  setData(updatedData); // This will update the parent component's state
};




  useEffect(() => {
    if (churchData.mailing_same_as_physical) {
      setUsePhysicalForMailing(true);
    } else {
      setUsePhysicalForMailing(false);
    }
  }, [churchData]);

  useEffect(() => {
    if (toastOpen) {
      const timer = setTimeout(() => setToastOpen(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [toastOpen]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 gap-1 text-[12px]">
      <Column title="Physical Location">
        <InputComponent
          label="Address"
          initialValue={churchData.address}
          placeholder="Address"
          fieldName="address"
          onInputChange={handleInputChange}
        />
        <InputComponent
          label="City"
          initialValue={churchData.city}
          placeholder="City"
          fieldName="city"
          onInputChange={handleInputChange}
        />
        <InputComponent
          label="State"
          initialValue={churchData.state}
          placeholder="State"
          fieldName="state"
          onInputChange={handleInputChange}
        />
        <InputComponent
          label="ZIP"
          initialValue={churchData.zip}
          placeholder="ZIP"
          fieldName="zip"
          onInputChange={handleInputChange}
        />


      </Column>

      {/* Mailing Address Column */}
      <Column title="Mailing Address">
        <div className="col-span-full mb-2">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={usePhysicalForMailing}
              onChange={(e) => handleMailingAddressToggle(e.target.checked)}
              className="mr-1 h-3 w-3"
            />
            <span>Same as physical address.</span>
          </label>
        </div>
        {!usePhysicalForMailing ? (
          <>
            <InputComponent
              label="Care of"
              initialValue={churchData.mailing_name || ""}
              placeholder="Care of"
              fieldName="mailing_name"
              onInputChange={handleInputChange}
              context={context}
            />
            <InputComponent
              label="Mail Address"
              initialValue={churchData.mailing_address}
              placeholder="Mailing Address"
              fieldName="mailing_address"
              onInputChange={handleInputChange}
              context={context}
            />
            <InputComponent
              label="Mail City"
              initialValue={churchData.mailing_city}
              placeholder="Mailing City"
              fieldName="mailing_city"
              onInputChange={handleInputChange}
              context={context}
            />
            <InputComponent
              label="Mail State"
              initialValue={churchData.mailing_state}
              placeholder="Mailing State"
              fieldName="mailing_state"
              onInputChange={handleInputChange}
              context={context}
            />
            <InputComponent
              label="Mail ZIP"
              initialValue={churchData.mailing_zip}
              placeholder="Mailing ZIP"
              fieldName="mailing_zip"
              onInputChange={handleInputChange}
              context={context}
            />
          </>
        ) : (
          <p>Using physical address for mailing</p>
        )}
      </Column>

      <Column title="Service Schedule">
        <InputComponent
          label="Sunday AM"
          initialValue={churchData.sunday_am}
          placeholder="Sunday AM"
          fieldName="sunday_am"
          onInputChange={handleInputChange}
        />
        <InputComponent
          label="Sunday PM"
          initialValue={churchData.sunday_pm}
          placeholder="Sunday PM"
          fieldName="sunday_pm"
          onInputChange={handleInputChange}
        />
        <InputComponent
          label="Midweek"
          initialValue={churchData.midweek}
          placeholder="Midweek"
          fieldName="midweek"
          onInputChange={handleInputChange}
        />
      </Column>

      {[1, 2, 3].map((i) => {
        const showContact =
          i === 1 || (i === 2 && showContact2) || (i === 3 && showContact3);
        if (showContact) {
          return (
            <Column key={i} title={`Contact ${i}`}>
              <div className="flex flex-col h-full">
                <div className="flex-grow">
                  <InputComponent
                    label="Name"
                    initialValue={churchData[`contact${i}_name`]}
                    placeholder="Name"
                    fieldName={`contact${i}_name`}
                    onInputChange={handleInputChange}
                    context={context}
                  />
                  <InputComponent
                    label="Phone"
                    initialValue={churchData[`contact${i}_phone`]}
                    placeholder="Phone"
                    fieldName={`contact${i}_phone`}
                    onInputChange={handleInputChange}
                    context={context}
                  />
                  <InputComponent
                    label="Email"
                    initialValue={churchData[`contact${i}_email`]}
                    placeholder="Email"
                    fieldName={`contact${i}_email`}
                    onInputChange={handleInputChange}
                    context={context}
                  />

                  {/* Display View Checkboxes */}
{/* Display View Checkboxes */}
<div className="mt-2">
  <div className="text-[12px] font-bold">Display on Maps:</div>
  <div className="flex flex-wrap">
    {["display_email", "display_phone"].map(
      (field) => (
        <label
          key={field}
          className="flex items-center w-1/2 m-0"
        >
          <input
            type="checkbox"
            checked={churchData[`contact${i}_${field}`]}
            onChange={() =>
              handleInputChange(
                `contact${i}_${field}`,
                !churchData[`contact${i}_${field}`]
              )
            }
            className="mr-1 h-3 w-3"
          />
          <span className="text-[12px]">
            {field.split("_")[1]}
          </span>
        </label>
      )
    )}
  </div>
</div>


                  {/* Preferred Contact Method Checkboxes */}
                  <div className="mt-2">
                    <div className="text-[12px] font-bold">
                      Preferred Contact Method (By Admin):
                    </div>
                    <div className="flex flex-wrap">
                      {[
                        "preferred_email",
                        "preferred_text",
                        "preferred_call",
                      ].map((field) => (
                        <label
                          key={field}
                          className="flex items-center w-1/2 m-0"
                        >
                          <input
                            type="checkbox"
                            checked={churchData[`contact${i}_${field}`]}
                            onChange={() =>
                              handleInputChange(
                                `contact${i}_${field}`,
                                !churchData[`contact${i}_${field}`]
                              )
                            }
                            className="mr-1 h-3 w-3"
                          />
                          <span className="text-[12px]">
                            {field.split("_")[1]}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mt-auto pt-2 flex justify-between items-center">
                  <div className="flex space-x-2">



                  </div>

                  {i > 1 && (
  <Tooltip.Provider>
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <button
          onClick={() => handleRemoveContact(i)}
          className="bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
        >
          <FaTrash className="w-4 h-4" />
        </button>
      </Tooltip.Trigger>
      <Tooltip.Content className="bg-gray-800 text-white text-xs rounded px-2 py-1">
        Remove Contact {i}
      </Tooltip.Content>
    </Tooltip.Root>
  </Tooltip.Provider>
)}
                </div>
              </div>
            </Column>
          );
        } else if (i === 2 && !showContact2) {
          return (
            <Column key="add-contact-2" title="Add Contact">
              <button
                onClick={handleAddContact}
                className="bg-green-500 text-white p-2 rounded w-full"
              >
                Add Contact 2
              </button>
            </Column>
          );
        } else if (i === 3 && !showContact3 && showContact2) {
          return (
            <Column key="add-contact-3" title="Add Contact">
              <button
                onClick={handleAddContact}
                className="bg-green-500 text-white p-2 rounded w-full"
              >
                Add Contact 3
              </button>
            </Column>
          );
        }
        return null;
      })}

      <Column title="Church Details">
      <Input
    label="Church Name"
    initialValue={churchData.name}
    placeholder="Church Name"
    onBlur={(value) => handleInputChange("name", value)}
  />
        <Input
          label="Website"
          initialValue={churchData.website}
          placeholder="Website"
          onBlur={(value) => handleInputChange("website", value)}
        />
        <Input
          label="Facebook"
          initialValue={churchData.facebook_link}
          placeholder="Facebook"
          onBlur={(value) => handleInputChange("facebook_link", value)}
        />
       


      </Column>


      <Dialog.Root open={popupOpen} onOpenChange={setPopupOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
          <Dialog.Content
            className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-md sm:w-auto"
            onOpenAutoFocus={(event) => event.preventDefault()}
          >
            <Dialog.Title className="text-lg font-bold mb-4 text-green-600">
              {popupContent.title}
            </Dialog.Title>
            <Dialog.Description className="mb-4 text-gray-700">
              {popupContent.message}
            </Dialog.Description>
            <div className="flex justify-center">
              <Dialog.Close asChild>
                <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors">
                  Close
                </button>
              </Dialog.Close>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>

      <Toast.Provider swipeDirection="down">
        <Toast.Root
          className="bg-red-500 text-white rounded-md shadow-lg p-4 items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-y-[var(--radix-toast-swipe-move-y)] data-[swipe=cancel]:translate-y-0 data-[swipe=end]:animate-swipeOut"
          open={toastOpen}
          onOpenChange={setToastOpen}
        >
          <Toast.Description className="font-semibold whitespace-pre-line">
            {toastMessage}
          </Toast.Description>
        </Toast.Root>
        <Toast.Viewport className="fixed bottom-4 left-1/2 transform -translate-x-1/2 flex flex-col gap-2 w-[90vw] sm:w-auto max-w-[90vw] m-0 list-none z-50 outline-none" />
      </Toast.Provider>


      <Dialog.Root open={openConfirmDialog} onOpenChange={setOpenConfirmDialog}>
  <Dialog.Portal>
    <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
    <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-md sm:w-auto">
      <Dialog.Title className="text-lg font-bold mb-4 text-red-600">
        Confirm Deletion
      </Dialog.Title>
      <Dialog.Description className="mb-4 text-gray-700">
        Are you sure you want to delete Contact {contactToDelete}?
      </Dialog.Description>
      <div className="flex justify-end space-x-2">
        <button
          onClick={() => setOpenConfirmDialog(false)}
          className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={confirmDeleteContact}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors"
        >
          Delete
        </button>
      </div>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>




      
    </div>
  );
});

export default SavePreview;